import SendDocumentDialog from './SendDocumentDialog.view';

export default SendDocumentDialog;
